export const fnCalculateTotalCartCost = (aCartItems) => {
  const nTotalCost = aCartItems.reduce(
    (nTotal, oCartItem) => nTotal + oCartItem.nPrice,
    0
  );
  return nTotalCost;
};

export default {};
